function Spoiler() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $btn = $wrap.find('.js-spoiler__btn');
    const $btnWrap = $wrap.find('.js-spoiler__btn-wrap');
    const $content = $wrap.find('.js-spoiler__content');

    const type = $wrap.data('spoiler-type');
    const btnExpandedClass = $wrap.data('btn-expanded-class');
    const btnCollapsedClass = $wrap.data('btn-collapsed-class');
    const expandedOnInit = $wrap.data('expanded') !== undefined;

    $btn.on('click', (e) => {
      e.preventDefault();
      if (type === 'blink') {
        const $target = $btnWrap.length > 0 ? $btnWrap : $btn;
        $target.animate(
          {
            opacity: 'hide',
          },
          300,
          () => {
            $content.animate({
              opacity: 'show',
            });
          },
);

        return;
      }

      $content.animate(
        {
          height: 'toggle',
        },
        300,
        () => {
          const expanded = $content.is(':visible');
          $btn.toggleClass(btnExpandedClass, expanded);
          $btn.toggleClass(btnCollapsedClass, !expanded);
        },
);
    });

    if (!expandedOnInit) {
      $content.hide();
      $btn.addClass(btnCollapsedClass);
      $btn.removeClass(btnExpandedClass);
    } else {
      $btn.addClass(btnExpandedClass);
      $btn.removeClass(btnCollapsedClass);
    }

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-spoiler').each(function init() {
      self.init(this);
    });
  };
}

export default new Spoiler();
